import { createDeferredI18n } from "#/shared/composables/useI18n";
import fallbackMessages from "#/shared/i18n/frontend.review_summary.json";

const { i18n, ready: whenI18nReady } = createDeferredI18n({ key: "review_summary", fallbackMessages });

export { whenI18nReady };

/**
 * Translates a key relative to the frontend.review_summary catalog.
 * @param {String} key
 * @returns {String}
 */
export function t(key) {
  return i18n.global.t(key);
}
